// extracted by mini-css-extract-plugin
export default {"Componenterror":"Component404_Componenterror__-iQtl","wrapper":"Component404_wrapper__xrLDY","error":"Component404_error__e1lP1"};